import React from 'react'

const CELL = 16

  const GridOverlay = ({ rows, cols, spi }) => {
   const safeSpi = Math.max(1, Number(spi) || 1)

  const w = cols * CELL
  const h = rows * CELL

  // Make SVG slightly larger to prevent edge clipping
  const svgW = w + 1
  const svgH = h + 1

  // Styling
  const minorStroke = 'rgba(0,0,0,0.25)'   // small cell lines
  const majorStroke = 'rgba(0,0,0,0.50)'   // 10x10 lines
  const borderStroke = majorStroke        // border matches 10x10 lines

  const minorWidth = 0.75
  const majorWidth = 2        // SAME as border
  const borderWidth = 2       // SAME as 10x10 lines

  return (
    <svg
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        shapeRendering: 'crispEdges',
      }}
      width={svgW}
      height={svgH}
      viewBox={`0 0 ${svgW} ${svgH}`}
      preserveAspectRatio="none"
    >
      {/* Vertical lines */}
{Array.from({ length: cols + 1 }).map((_, i) => {
  const x = i * CELL + 0.5
  const isMajor = i % safeSpi === 0
  return (
    <line
      key={`v-${i}`}
      x1={x}
      y1={0.5}
      x2={x}
      y2={h + 0.5}
      stroke={isMajor ? majorStroke : minorStroke}
      strokeWidth={isMajor ? majorWidth : minorWidth}
    />
  )
})}

{/* Horizontal lines */}
{Array.from({ length: rows + 1 }).map((_, i) => {
  const y = i * CELL + 0.5
  const isMajor = i % safeSpi === 0
  return (
    <line
      key={`h-${i}`}
      x1={0.5}
      y1={y}
      x2={w + 0.5}
      y2={y}
      stroke={isMajor ? majorStroke : minorStroke}
      strokeWidth={isMajor ? majorWidth : minorWidth}
    />
  )
})}

      {/* Outer Border (drawn last for consistency) */}
      <rect
        x="0.5"
        y="0.5"
        width={w}
        height={h}
        fill="none"
        stroke={borderStroke}
        strokeWidth={borderWidth}
      />
    </svg>
  )
}

export default GridOverlay